/* eslint-disable react/jsx-one-expression-per-line */
import React, { useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { useParams, useHistory } from 'react-router-dom';
// @ts-ignore
import { Icon } from '@els/els-react--icon';
// @ts-ignore
import { Loader } from '@els/els-react--loader';
// @ts-ignore
import { Flyout } from '@els/els-react--flyout';
// @ts-ignore
import { ButtonWithIcon } from '@els/els-react--button';
// @ts-ignore
import { LinkElement } from '@els/els-react--link-element';
// @ts-ignore
import { generatePath } from 'react-router';
// @ts-ignore
import Clock from '../../assets/img/0123-clock.svg';
// @ts-ignore
import DemonstrateImpact from '../../assets/img/0016-demonstrate-impact.svg';
// @ts-ignore
import BuildMyKnowledge from '../../assets/img/0012-build-my-knowledge.svg';
// @ts-ignore
import EdenChecklist from '../../assets/img/eden-checklist.svg';
// @ts-ignore
import No_Favorite_Skills from '../../assets/img/No_Favorite_Skills.svg';

import { getEbpcSkills } from '../evidence-based-practice-changes/ebpc-thunk';
import { getUserFavoriteContent } from '../favorites-content/skills-favorite-tab/skills-favorite-tab-thunk';
import {
    selectFirstName,
    selectUserId,
    selectClientId,
    selectUserAuthenticationStatus,
    selectIsUserAdmin,
    selectSkillEvaluator,
} from '../login/login-selector';
import { selectClientId as selectClientIdforReference } from '../referential-access/referential-access-selector';
import UpdatesCard from './components/updates-card/updates-cards';
import {
    selectskillsDetails,
    selectEbpcAsyncStatus,
} from '../evidence-based-practice-changes/ebpc-selector';
import {
    selectfavoriteSkillList,
    selectUserFavoriteContentAsyncStatus,
} from '../favorites-content/skills-favorite-tab/skills-favorite-tab-selector';
import { formatDate } from '../../../libs/utils/helper/date-helper';
import NavigationCard from './components/navigation-card/navigation-card';
import { selectTypeOfContentForClientAsyncStatus } from './home-selector';
import { getTypeOfContentExistsForClientThunk } from './home-thunk';
import {
    getAllActiveSkills,
    getRecentViewedSkills,
} from '../search/search-thunk';
import {
    isPending,
    hasSucceeded,
    hasFailed,
} from '../../../libs/utils/constants/async-status';
import {
    selectAppConfigs,
    selectAppRuntimeConfigsAsyncStatus,
} from '../app-config/app-config-selector';
import ServerErrorPage from '../../components/server-error-page/server-error-page';
import SearchBox from './components/search-box/search-box';
import './home.scss';
import { LoggedOutView } from '../../components/logged-out-view/logged-out-view';
import { ZeroState } from '../../components/zero-state-updates-card/zero-state-updates-card';
import Routes from '../../constants/routes';
import MyLearningCard from './components/my-learning-card/my-learning-card';
import BackButtonNavigationTracking from '../../utils/back-button-helper';
import { cancelledAsyncLogin } from '../login/login-slice';
import { resetFacetData } from '../search/search-slice';
import { PageTitle } from '../../utils/page-title';

const Home = () => {
    const baseClassName = 'home';
    const dispatch = useDispatch();
    const firstName = useSelector(selectFirstName);
    const appConfigs = useSelector(selectAppConfigs);
    const appRuntimeConfigsAsyncStatus = useSelector(
        selectAppRuntimeConfigsAsyncStatus
    );
    const isUserAdmin = useSelector(selectIsUserAdmin);
    const history = useHistory();
    const [error, setError] = useState(false);
    const [homeAsyncStatus, setHomeAsyncStatus] = useState('initial');
    const [search, setSearch] = useState('');
    const contentTypesAsyncStatus = useSelector(
        selectTypeOfContentForClientAsyncStatus
    );

    const isUserloggedIn: boolean = useSelector(selectUserAuthenticationStatus);
    const userId: number = useSelector(selectUserId);

    const clientIdFromLogin = useSelector(selectClientId);
    const clientIdFromReferential = useSelector(selectClientIdforReference);
    const clientId: number = isUserloggedIn
        ? clientIdFromLogin
        : clientIdFromReferential;
    const ebpcSkills: any = useSelector(selectskillsDetails);
    const isSkillEvaluator = useSelector(selectSkillEvaluator);
    const ebpcAsyncStatus = useSelector(selectEbpcAsyncStatus);
    const userFavoriteContentAsyncStatus = useSelector(
        selectUserFavoriteContentAsyncStatus
    );
    const { ecrId } = useParams<{ ecrId: string }>();

    useEffect(() => {
        if (!(localStorage.getItem('IS_USER_AUTHENTICATED') === 'true')) {
            dispatch(cancelledAsyncLogin());
        }
        if (localStorage.getItem('IS_USER_AUTHENTICATED') === 'true') {
            dispatch(getRecentViewedSkills());
        }
        dispatch(getTypeOfContentExistsForClientThunk(clientId));
        dispatch(getEbpcSkills());
        dispatch(getAllActiveSkills({ clientId, ecrId }));
        dispatch(resetFacetData());
    }, []);

    useEffect(() => {
        if (isPending(contentTypesAsyncStatus)) {
            setHomeAsyncStatus('loading');
        } else if (hasSucceeded(contentTypesAsyncStatus)) {
            setHomeAsyncStatus('success');
        }
        if (hasFailed(contentTypesAsyncStatus)) {
            setError(true);
        }
    }, [contentTypesAsyncStatus]);

    const redirectToCreate = () =>
        window.open(`${appConfigs.AXON_BASE_URL}/education/assign-education`);
    const redirectToManage = () =>
        window.open(`${appConfigs.AXON_BASE_URL}/education/assignments`);
    const redirectToView = () =>
        window.open(`${appConfigs.REPORTS_BASE_URL}/ecl-reports/reports`);
    const redirectToGrading = () =>
        window.open(`${appConfigs.NEURON_BASE_URL}/evaluate-skills-checklists`);

    const handleRedirectToSkillDetail = (courseId: any) => {
        const redirectLink = generatePath(Routes.SKILL_LAUNCH, {
            id: courseId,
            ecrId,
        });
        history.push(`${redirectLink}/`);
        window.scrollTo(0, 0);
    };

    const handleRedirectToFavoriteContentDetails = () => {
        const redirectLink = generatePath(Routes.FAVORITES_CONTENT, { ecrId });
        history.push(`${redirectLink}/`);
        window.scrollTo(0, 0);
    };

    const handleRedirectToEBPCDetails = () => {
        const redirectLink = generatePath(Routes.EVIDENCE_BASED_PRACTICE, {
            ecrId,
        });
        history.push(`${redirectLink}/`);
        window.scrollTo(0, 0);
    };

    const favoriteSkills: any = useSelector(selectfavoriteSkillList);

    const renderEbpcSkills = () => {
        if (ebpcSkills || ebpcSkills.length > 0) {
            const sortedebpcSkills = ebpcSkills.toSorted((a: any, b: any) => {
                const dateComparison =
                    new Date(b.dateUpdated).getTime() -
                    new Date(a.dateUpdated).getTime();
                if (dateComparison !== 0) {
                    return dateComparison;
                }
                return a.skillName.localeCompare(b.skillName);
            });
            return sortedebpcSkills.slice(0, 3).map((skill: any) => (
                <div key={skill.id} className={`${baseClassName}__ebpc-skill`}>
                    <LinkElement
                        href={`${generatePath(Routes.SKILL_LAUNCH, {
                            id: skill.courseId,
                            ecrId,
                        })}/`}
                        iconSprite="ChevronRight"
                        iconSize="xs"
                        iconRight
                        inline
                        onClick={
                            (e: React.MouseEvent) => {
                                e.preventDefault();
                                handleRedirectToSkillDetail(skill.courseId);
                            }
                            // eslint-disable-next-line react/jsx-curly-newline
                        }
                    >
                        <div>
                            <p>{skill.skillName}</p>
                            <p>
                                Updated{' '}
                                {formatDate(skill.dateUpdated, 'MMMM yyyy')}
                            </p>
                        </div>
                    </LinkElement>
                </div>
            ));
        }
        return null;
    };

    if (isUserloggedIn) {
        useEffect(() => {
            dispatch(getUserFavoriteContent());
        }, []);
    }

    const renderFavoriteSkills = () => {
        if (favoriteSkills && favoriteSkills.length > 0) {
            const sortedFavoriteSkills = favoriteSkills.toSorted(
                (a: any, b: any) => a.skillName.localeCompare(b.skillName)
            );

            return sortedFavoriteSkills
                .slice(0, 5)
                .map((favoriteSkill: any) => (
                    <div
                        key={favoriteSkill.id}
                        className={`${baseClassName}__favorite-skill`}
                    >
                        <LinkElement
                            href={`${generatePath(Routes.SKILL_LAUNCH, {
                                id: favoriteSkill.courseId,
                                ecrId,
                            })}/`}
                            iconSprite="ChevronRight"
                            iconSize="xs"
                            iconRight
                            inline
                            onClick={
                                (e: React.MouseEvent) => {
                                    e.preventDefault();
                                    handleRedirectToSkillDetail(
                                        favoriteSkill.courseId
                                    );
                                }
                                // eslint-disable-next-line react/jsx-curly-newline
                            }
                        >
                            <div>
                                <p>{favoriteSkill.skillName}</p>
                            </div>
                        </LinkElement>
                    </div>
                ));
        }
        return null;
    };

    return (
        <div>
            {error ? (
                <ServerErrorPage />
            ) : (
                <>
                    <PageTitle title="Home | Clinical Skills" />
                    {isPending(homeAsyncStatus) && <Loader isVisible />}
                    <div className={`${baseClassName}`}>
                        <div className={`${baseClassName}__top-content`}>
                            <SearchBox
                                baseClassName={baseClassName}
                                firstName={firstName}
                                search={search}
                                setSearch={setSearch}
                                isUserAdmin={isUserAdmin}
                            />
                            <MyLearningCard
                                clientId={clientId}
                                userId={userId}
                                isUserloggedIn={isUserloggedIn}
                            />
                        </div>
                        {isUserAdmin &&
                            isPending(appRuntimeConfigsAsyncStatus) && (
                                <Loader
                                    isVisible
                                    isBlocking={false}
                                    className={`${baseClassName}__admin-tools-loader`}
                                />
                            )}
                        {isUserAdmin &&
                            hasSucceeded(appRuntimeConfigsAsyncStatus) && (
                                <div
                                    className={`${baseClassName}__admin-tools`}
                                >
                                    <h2
                                        className={`${baseClassName}__admin-tools-title`}
                                    >
                                        Admin tools
                                    </h2>
                                    <div
                                        className={`${baseClassName}__admin-tools-card-wrapper`}
                                    >
                                        <NavigationCard
                                            onClickNavigateTo={redirectToCreate}
                                            href={`${appConfigs.AXON_BASE_URL}/education/assign-education`}
                                            cardLogo={BuildMyKnowledge}
                                            title="Create an assignment"
                                            description="Empower your learners with the knowledge they need."
                                            buttonText="Create"
                                            ariaLabel="Create assignment"
                                        />
                                        <NavigationCard
                                            onClickNavigateTo={redirectToManage}
                                            href={`${appConfigs.AXON_BASE_URL}/education/assignments`}
                                            cardLogo={Clock}
                                            title="Manage assignments"
                                            description="Review or edit any assignment you created."
                                            buttonText="Manage"
                                            ariaLabel="Manage assignments"
                                        />
                                        <NavigationCard
                                            onClickNavigateTo={redirectToView}
                                            href={`${appConfigs.REPORTS_BASE_URL}/ecl-reports/reports`}
                                            cardLogo={DemonstrateImpact}
                                            title="Reporting"
                                            description="Keep track of your learner's activities across content."
                                            buttonText="View"
                                            ariaLabel="View reports"
                                        />
                                    </div>
                                </div>
                            )}
                        {isSkillEvaluator &&
                            isPending(appRuntimeConfigsAsyncStatus) && (
                                <Loader
                                    isVisible
                                    isBlocking={false}
                                    className={`${baseClassName}__admin-tools-loader`}
                                />
                            )}
                        {isSkillEvaluator &&
                            hasSucceeded(appRuntimeConfigsAsyncStatus) && (
                                <div
                                    className={`${baseClassName}__admin-tools`}
                                >
                                    <div
                                        className={`${baseClassName}__admin-tools-card-wrapper`}
                                    >
                                        <NavigationCard
                                            onClickNavigateTo={
                                                redirectToGrading
                                            }
                                            href={`${appConfigs.NEURON_BASE_URL}/evaluate-skills-checklists`}
                                            cardLogo={EdenChecklist}
                                            title="Evaluate Skills checklists"
                                            description="View and grade nurses that need to complete Skills Checklists."
                                            buttonText="Grade"
                                            ariaLabel="Grade skills checklists"
                                            skillEvaluatorClass={
                                                isSkillEvaluator
                                            }
                                        />
                                    </div>
                                </div>
                            )}
                        <div className={`${baseClassName}__clinical-updates`}>
                            <h2
                                className={`${baseClassName}__clinical-updates-title`}
                            >
                                Clinical updates & favorites
                            </h2>
                            <div
                                className={`${baseClassName}__clinical-updates-wrapper`}
                            >
                                <div
                                    className={`${baseClassName}__clinical-updates-wrapper-container`}
                                >
                                    <div
                                        className={`${baseClassName}__clinical-updates-wrapper-container-ebpc`}
                                    >
                                        <h3>Evidence Based Practice Changes</h3>
                                        <Flyout
                                            flyout="Evidence Based Practice Changes are any Skills you have licensed that have had clinical pratice changes made in the past 3 months."
                                            shouldCloseOnESC
                                            trigger="hover"
                                            placement="top-start"
                                            breakpoint={900}
                                            width="300"
                                        >
                                            <ButtonWithIcon
                                                className={`${baseClassName}__clinical-updates-wrapper-container-ebpc-icon`}
                                                sprite={
                                                    Icon.Sprites
                                                        .INFORMATION_OUTLINE_CIRCLE
                                                }
                                                iconOnly
                                                onClick={(e: any) =>
                                                    e.preventDefault()
                                                }
                                                type={
                                                    ButtonWithIcon.Types
                                                        .BORDERLESS
                                                }
                                            >
                                                Information
                                            </ButtonWithIcon>
                                        </Flyout>
                                    </div>

                                    <div
                                        className={`${baseClassName}__clinical-updates-wrapper-container-cardwrapper`}
                                    >
                                        {isPending(ebpcAsyncStatus) && (
                                            <Loader
                                                className={`${baseClassName}__clinical-updates-loader`}
                                                isVisible
                                                isBlocking={false}
                                            />
                                        )}
                                        {!isPending(ebpcAsyncStatus) && (
                                            <div>
                                                {ebpcSkills &&
                                                ebpcSkills.length > 0 ? (
                                                    <UpdatesCard
                                                        title="New evidence based practice changes"
                                                        description={renderEbpcSkills()}
                                                        buttonText="View more clinical updates"
                                                        href={`${generatePath(
                                                            Routes.EVIDENCE_BASED_PRACTICE,
                                                            { ecrId }
                                                        )}/`}
                                                        onClickNavigateTo={
                                                            handleRedirectToEBPCDetails
                                                        }
                                                    />
                                                ) : (
                                                    <ZeroState
                                                        image={
                                                            No_Favorite_Skills
                                                        }
                                                        title="No new updates for your licensed skills."
                                                        description="Check back soon."
                                                    />
                                                )}
                                            </div>
                                        )}
                                    </div>
                                </div>
                                <div
                                    className={`${baseClassName}__clinical-updates-wrapper-container`}
                                >
                                    <h3>Favorites</h3>
                                    <div
                                        className={`${baseClassName}__clinical-updates-wrapper-container-cardwrapper`}
                                    >
                                        {!isUserloggedIn && <LoggedOutView />}
                                        {isUserloggedIn && (
                                            <>
                                                {isPending(
                                                    userFavoriteContentAsyncStatus
                                                ) && (
                                                    <Loader
                                                        className={`${baseClassName}__clinical-updates-loader`}
                                                        isVisible
                                                        isBlocking={false}
                                                    />
                                                )}
                                                {!isPending(
                                                    userFavoriteContentAsyncStatus
                                                ) && (
                                                    <div>
                                                        {favoriteSkills &&
                                                        favoriteSkills.length >
                                                            0 ? (
                                                            <UpdatesCard
                                                                className={`${baseClassName}__clinical-updates-wrapper-container-cardwrapper`}
                                                                title="New evidence based practice changes"
                                                                description={renderFavoriteSkills()}
                                                                buttonText="View more favorites"
                                                                href={`${generatePath(
                                                                    Routes.FAVORITES_CONTENT,
                                                                    { ecrId }
                                                                )}/`}
                                                                onClickNavigateTo={
                                                                    handleRedirectToFavoriteContentDetails
                                                                }
                                                            />
                                                        ) : (
                                                            <ZeroState
                                                                image={
                                                                    No_Favorite_Skills
                                                                }
                                                                title="You have no favorite skills. To add one,"
                                                                description="open the skill and click 'Add to favorites'."
                                                            />
                                                        )}
                                                    </div>
                                                )}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </>
            )}
        </div>
    );
};
export default BackButtonNavigationTracking('Home', Home);
